import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

// -------- global meta + snapshot list --------
const MetaCtx = createContext(null);
export const useMeta = () => useContext(MetaCtx);

export function MetaProvider({ children }) {
  const [meta, setMeta] = useState(null);
  const [snapshots, setSnapshots] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [m, s] = await Promise.all([api.get("/meta"), api.get("/snapshots")]);
      setMeta(m.data);
      setSnapshots(s.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <MetaCtx.Provider value={{ meta, snapshots, loading, refresh }}>
      {children}
    </MetaCtx.Provider>
  );
}

// -------- currently opened snapshot (scoped workspace) --------
const SnapCtx = createContext(null);
export const useSnapshot = () => useContext(SnapCtx);
export const SnapProvider = SnapCtx.Provider;
